import { useEffect, useState } from "react";
import FeedbackForm from "./FeedbackForm";
import { supabase } from "./supabaseClient";
import { feedbackAudienceForUser } from "./feedbackInvitationPersistence";

export const isFeedbackPath = (pathname, hash = "") => pathname === "/feedback" || pathname === "/feedback/" || hash === "#/feedback" || hash === "#feedback";

export default function FeedbackDeepLinkPage() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    let active = true;
    void supabase.auth.getUser().then(({ data }) => {
      if (!active) return;
      const authUser = data?.user;
      setUser(authUser ? { userId: authUser.id, email: authUser.email || null } : null);
    });
    return () => { active = false; };
  }, []);

  const audience = feedbackAudienceForUser(user?.userId);
  const close = () => { window.location.href = "/"; };

  return <FeedbackForm
    user={user}
    audience={audience}
    origin="email_feedback_link"
    context={{ screen: "feedback_deep_link", access_mode: user ? "authenticated" : "guest", place_id: null }}
    onClose={close}
  />;
}
